import React, { useState, useEffect, useMemo } from 'react';
import { KTSVG } from '../../../../../_mexablock/helpers';
import { useFormik } from 'formik';
import {
  useGetAllCompany,
} from '../hooks/AccountStatmentHook';
import { getAllSelect } from '../../../../service/distribuidores/Distribuidores';
import Select from 'react-select';
import { FilterMov } from '../../activaciones/_modals/FilterDate';
import { SimpleAlert } from '../../../../../_mexablock/helpers';

type Props = {
  initFilterValues: any;
  onCleanFilter: () => void;
  onSearchFilter: (values: any) => void;
  showFilterCode: boolean;
  userRoles: any;
};

const Filter: React.FC<Props> = ({
  initFilterValues,
  onSearchFilter,
  onCleanFilter,
  showFilterCode,
  userRoles,
}) => {
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const [selectedTipo, setSelectedTipo] = useState<any>(null);
  const [selectedUsuario, setSelectedUsuario] = useState<any>(null);
  const [changeName, setChangeName] = useState(false);

  // Verificar si el usuario tiene roles que NO deben ver los filtros
  const shouldShowFilters = useMemo(() => {
    if (!showFilterCode || !userRoles.length) return false;

    const restrictedRoles = ['ADMIN_COMPANY', 'ADMIN_PARTNER'];
    const hasRestrictedRole = userRoles.some((role: any) =>
      restrictedRoles.includes(role.code),
    );

    return !hasRestrictedRole;
  }, [showFilterCode, userRoles]);

  // Solo cargar empresas si se deben mostrar los filtros
  const { data: company } = useGetAllCompany(shouldShowFilters);
  const [distribuidores, setDistribuidores] = useState<any[]>([]);
  const [loadingDistribuidores, setLoadingDistribuidores] = useState(false);

  useEffect(() => {
    if (selectedTipo?.value === 'distributor') {
      const fetchDistribuidores = async () => {
        setLoadingDistribuidores(true);
        try {
          const response = await getAllSelect(null);
          setDistribuidores(response);
        } catch (error) {
          console.error(error);
          SimpleAlert('Error al cargar distribuidores', 3000, 'error');
        } finally {
          setLoadingDistribuidores(false);
        }
      };

      if (distribuidores.length === 0) {
        fetchDistribuidores();
      }
    }
  }, [selectedTipo, distribuidores.length]);

  const tiposCliente = [
    {
      value: 'EMP',
      label: 'Empresa',
    },
    {
      value: 'SOC',
      label: 'Socio',
    },
    {
      value: 'distributor',
      label: 'Distribuidor',
    },
  ];

  useEffect(() => {
    if (initFilterValues) {
      setFilterValues(initFilterValues);
    }
  }, [initFilterValues]);

  const formFilter = useFormik({
    initialValues: filterValues,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      onSearchFilter({ ...values, filter: 1 });
    },
  });

  return (
    <>
      <div className="card-title align-items-start flex-column">
        <a
          href="#/"
          className={
            formFilter.values.filter !== 0
              ? ' btn btn-sm btn-primary'
              : 'btn btn-sm btn-light-primary'
          }
          data-kt-menu-trigger="click"
          data-kt-menu-placement="right-start"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen031.svg"
            className="svg-icon-5 svg-icon-gray-500 me-1"
          />
          Filtrar
        </a>
        <div
          className="menu menu-sub menu-sub-dropdown w-300px w-md-300px ms-2"
          data-kt-menu="true"
        >
          <div className="px-7 py-5">
            <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
          </div>

          <div className="separator border-gray-200"></div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formFilter.handleSubmit}
          >
            <div className="px-7 py-5">
              {shouldShowFilters ? (
                <>
                  <div className="mb-5" onClick={(e) => e.stopPropagation()}>
                    <label className="form-label fw-bold">Tipo:</label>
                    <Select
                      options={tiposCliente}
                      styles={{
                        placeholder: (provided, state) => ({
                          ...provided,
                          color: '#181c32',
                        }),
                        indicatorSeparator: (provided, state) => ({
                          ...provided,
                          display: 'none',
                        }),
                        dropdownIndicator: (provided, state) => ({
                          ...provided,
                          color: '#7E8199',
                        }),
                        control: (provided, state) => ({
                          ...provided,
                          border: '1px solid #e4e6ef',
                          borderRadius: '6px',
                          padding: '3px',
                          fontSize: '1.1rem',
                          boxShadow: 'none',
                          backgroundColor: state.isDisabled
                            ? '#EFF2F5'
                            : 'white',
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          fontSize: '1.1rem',
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      placeholder="Selecciona tipo"
                      isSearchable={false}
                      noOptionsMessage={() => 'No se encontraron registros'}
                      onChange={(option: any) => {
                        setSelectedTipo(option);
                        setSelectedUsuario(null);
                        formFilter.setFieldValue('codeAccount', '');
                      }}
                      value={selectedTipo}
                      closeMenuOnSelect={true}
                    />
                  </div>
                  {selectedTipo && (
                    <div className="mb-5" onClick={(e) => e.stopPropagation()}>
                      <label className="form-label fw-bold">Usuario:</label>
                      <Select
                        isLoading={loadingDistribuidores}
                        isDisabled={
                          !selectedTipo ||
                          (selectedTipo.value === 'distributor' &&
                            loadingDistribuidores)
                        }
                        options={
                          selectedTipo.value === 'distributor'
                            ? distribuidores
                            : company
                                .filter(
                                  (item: any) =>
                                    item.type?.code === selectedTipo.value,
                                )
                                .map((item: any) => ({
                                  value: item.id,
                                  label: item.name,
                                  id: item.id,
                                }))
                        }
                        styles={{
                          placeholder: (provided, state) => ({
                            ...provided,
                            color: '#181c32',
                          }),
                          indicatorSeparator: (provided, state) => ({
                            ...provided,
                            display: 'none',
                          }),
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            color: '#7E8199',
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            border: '1px solid #e4e6ef',
                            borderRadius: '6px',
                            padding: '3px',
                            fontSize: '1.1rem',
                            boxShadow: 'none',
                            backgroundColor: state.isDisabled
                              ? '#EFF2F5'
                              : 'white',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            fontSize: '1.1rem',
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Selecciona usuario"
                        noOptionsMessage={() => 'No se encontraron registros'}
                        onChange={(option: any) => {
                          setSelectedUsuario(option);
                          formFilter.setFieldValue('codeAccount', option?.id);
                        }}
                        value={selectedUsuario}
                        closeMenuOnSelect={true}
                      />
                    </div>
                  )}
                </>
              ) : null}
              <div className="mb-5">
                <FilterMov
                  valueInit={formFilter.values.init_date}
                  valueEnd={formFilter.values.end_date}
                  setInitDate={(date: string) => {
                    formFilter.setFieldValue('init_date', date);
                    setChangeName(false);
                  }}
                  setEndDate={(date: string) => {
                    formFilter.setFieldValue('end_date', date);
                    setChangeName(false);
                  }}
                  onCleanFilter={() => {
                    formFilter.setFieldValue('init_date', '');
                    formFilter.setFieldValue('end_date', '');
                    setChangeName(true);
                  }}
                  changeName={changeName}
                />
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="reset"
                  className="btn btn-sm btn-white btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  onClick={() => {
                    formFilter.resetForm();
                    setSelectedTipo(null);
                    setSelectedUsuario(null);
                    onCleanFilter();
                  }}
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                >
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export { Filter };
